







import { defineComponent } from '@vue/composition-api';
import { useStore } from '@/store';
import { MutationTypes } from '@/store/mutations';

export default defineComponent({
    name: 'VehicleAction',
    components: {},
    props: {
        index: { type: Number, required: true },
        vehicleExists: { type: Boolean, required: true }
    },
    setup () {
        const store = useStore();
        const openModal = index => {
            store.commit(MutationTypes.OpenDeleteCarModal, index);
        };
        return { openModal };
    }
});
